import { OrderModePage } from '../modules/productsModule/screens';

export default OrderModePage;
